export interface CatalogApiErrorItem {
  code?: string;
  target?: string;
  message?: string;
}

function isCatalogApiErrorItem(value: unknown): value is CatalogApiErrorItem {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const { message } = value as CatalogApiErrorItem;
  return typeof message === "string" && message.trim().length > 0;
}

function extractCatalogApiErrors(errorData: unknown): CatalogApiErrorItem[] {
  if (Array.isArray(errorData)) {
    return errorData.filter(isCatalogApiErrorItem);
  }

  if (typeof errorData === "object" && errorData !== null) {
    const record = errorData as Record<string, unknown>;

    if (Array.isArray(record.errors)) {
      return record.errors.filter(isCatalogApiErrorItem);
    }

    if (isCatalogApiErrorItem(errorData)) {
      return [errorData];
    }
  }

  return [];
}

export function getCatalogApiErrorMessage(
  errorData: unknown,
  fallback: string,
): string {
  const messages = extractCatalogApiErrors(errorData).map(
    (item) => item.message?.trim() ?? "",
  );

  const uniqueMessages = [...new Set(messages.filter(Boolean))];

  if (uniqueMessages.length === 0) {
    return fallback;
  }

  return uniqueMessages.join(" ");
}
